import React from "react";
import "./OptiesTab.css";
import RadioBlocksExtended from "src/components/Input/RadioBlocksExtended/RadioBlocksExtended";
import { useConfiguration } from "src/contexts/ConfigurationContext";
import SelectUnselectExtended from "src/components/Input/SelectUnselectExtended/SelectUnselectExtended";
import { initialConfiguration } from "src/hooks/useConfigurationState";
import { OptionsMaterial } from "src/types/configuration";

const OptiesTab: React.FC = () => {
  const {
    state,
    setDimensions,
    setRoofMaterial,
    setOptionsMaterial,
    configuration,
  } = useConfiguration();

  const handlePoer = (value: string) => {
    if (value !== state.optionsMaterial.poer)
      setOptionsMaterial({ ...state.optionsMaterial, poer: value });
  };

  const handleFundering = (value: string) => {
    if (value !== state.optionsMaterial.fundering)
      setOptionsMaterial({ ...state.optionsMaterial, fundering: value });
  };

  const handleMontage = (enabled: boolean) => {
    if (state.optionsMaterial.montage !== enabled)
      setOptionsMaterial({ ...state.optionsMaterial, montage: enabled });
  };

  const isMontageSelected = state.optionsMaterial.montage === true;

  // Every option in this tab is priced as a surcharge over its group's default
  // choice, which for all three groups is "not selected". Only the group's own
  // field is varied; the rest of the configuration stays as it is.
  const optionSurcharge = (
    option: Partial<OptionsMaterial>,
    groupDefault: Partial<OptionsMaterial>
  ) =>
    configuration.calculationService.getSurcharge(
      { optionsMaterial: { ...state.optionsMaterial, ...option } },
      { optionsMaterial: { ...state.optionsMaterial, ...groupDefault } }
    );

  const poerSurcharge = (poer: string) =>
    optionSurcharge(
      { poer },
      { poer: initialConfiguration.optionsMaterial.poer }
    );

  const funderingSurcharge = (fundering: string) =>
    optionSurcharge(
      { fundering },
      { fundering: initialConfiguration.optionsMaterial.fundering }
    );

  // Shown as whole euros, rounded up. The price table keeps the exact amount.
  const montageTotal = Math.ceil(
    optionSurcharge(
      { montage: true },
      { montage: initialConfiguration.optionsMaterial.montage }
    )
  );
  const poers = [
    {
      id: -1,
      name: "Geen",
      value: "empty",
      imageUrl: `${process.env.PUBLIC_URL}/images/empty.png`,
      price: poerSurcharge("empty"),
      color: "transparent",
      description:
        "",

      component: undefined,
    },
    {
      id: 0,
      name: "Poeren",
      value: "poer",
      imageUrl: `${process.env.PUBLIC_URL}/images/poer.jpg`,
      price: poerSurcharge("poer"),
      description:
        "",

      component: undefined,
    },
    {
      id: 1,
      name: "HWA Poeren",
      value: "hwapoer",
      imageUrl: `${process.env.PUBLIC_URL}/images/hwa_poer_2.png`,
      price: poerSurcharge("hwapoer"),
      description:
        "",

      component: undefined,
    },
  ];

  const funderings = [
    {
      id: -1,
      name: "Geen",
      value: "empty",
      imageUrl: `${process.env.PUBLIC_URL}/images/empty.png`,
      price: funderingSurcharge("empty"),
      color: "transparent",
      description:
        "",

      component: undefined,
    },
    {
      id: 0,
      name: "Fundatiekoker",
      value: "fundatiekoker",
      price: funderingSurcharge("fundatiekoker"),
      imageUrl: `${process.env.PUBLIC_URL}/images/Fundatiekoker_2.png`,
      description:
        "",

      component: undefined,
    },
    // {
    //   id: 1,
    //   name: "Fundatiekoker en poer",
    //   value: "fundatiekokerpoer",
    //   price: 0,
    //   imageUrl: `${process.env.PUBLIC_URL}/images/Fundatiekoker_and_poeren.jpg`,
    //   description:
    //     "",

    //   component: undefined,
    // },
  ];

  const PoerComponent = () => {
    return (
      <RadioBlocksExtended
        blocks={poers}
        value={state.optionsMaterial.poer}
        onChange={handlePoer}
        className="inner_child"
      />
    );
  };

  const FunderingComponent = () => {
    return (
      <RadioBlocksExtended
        blocks={funderings}
        value={state.optionsMaterial.fundering}
        onChange={handleFundering}
        className="inner_child"
      />
    );
  };

  let doorcheck = false;

  window.CONF.house.walls.map((item) => {
    if (
      item.sections[0].type.startsWith("door") ||
      item.sections[0].type.startsWith("window")
    )
      doorcheck = true;
  });

  if (!doorcheck) handleFundering("empty");

  return (
    <div className="fundering-tab">
      <SelectUnselectExtended
        name="Poeren"
        deselectByCheckboxOnly={true}
        imageUrl={
          `${process.env.PUBLIC_URL}/images/poeren.jpg`
        }
        description=""
        color="transparent"
        isSelected={
          state.optionsMaterial.poer === "poer" ||
          state.optionsMaterial.poer === "hwapoer"
        }
        onSelect={
          // () =>
          // setOptionsMaterial({
          //   ...state.optionsMaterial,
          //   poer: "poer",
          // })
          () => true
        }
        onUnselect={
          // () =>
          // setOptionsMaterial({
          //   ...state.optionsMaterial,
          //   poer: "",
          // })
          () => false
        }
        // componentIsVisible={state.lights.enabled}
        Component={PoerComponent}
        selectedNames={
          poers.find((i) => i.value === state.optionsMaterial.poer)?.name || ""
        }
      />
      {doorcheck && (
        <SelectUnselectExtended
          name="Fundatiekoker"
          imageUrl={
            `${process.env.PUBLIC_URL}/images/fundatiekoker_prev.jpg`
          }
          color="transparent"
          description=""
          isSelected={
            state.optionsMaterial.fundering === "fundatiekoker" ||
            state.optionsMaterial.fundering === "fundatiekokerpoer"
          }
          onSelect={() =>
            // setOptionsMaterial({
            //   ...state.optionsMaterial,
            //   fundering: "fundatiekoker",
            // })
            () =>
              true}
          onUnselect={
            // () =>
            // setOptionsMaterial({
            //   ...state.optionsMaterial,
            //   fundering: "",
            // })
            () => false
          }
          // componentIsVisible={state.lights.enabled}
          Component={FunderingComponent}
          selectedNames={
            funderings.find((i) => i.value === state.optionsMaterial.fundering)
              ?.name || ""
          }
        />
      )}
      <SelectUnselectExtended
        name="Montage (incl. werkbezoek vooraf)"
        imageUrl={`${process.env.PUBLIC_URL}/images/Montage-conf.png`}
        color="transparent"
        description="U kunt gebruik maken van onze montageservice. De montagekosten zijn inclusief voorrijkosten, een werkbezoek op locatie en het monteren van de door u gekozen producten."
        price={montageTotal}
        isSelected={isMontageSelected}
        onSelect={() => handleMontage(true)}
        onUnselect={() => handleMontage(false)}
        selectedNames={isMontageSelected ? "Montage actief" : ""}
      />
    </div>
  );
};

export default OptiesTab;
